import React, { useCallback, useEffect, useState } from "react";
import { View, Text, ScrollView, StyleSheet, Image, Pressable } from "react-native";

import { debounce } from "lodash";
import { store } from "../../store/store";
import { View as AnimatableView } from "react-native-animatable";

import { getChemistSiteUrl } from "../../utils/services/chemist/chemistSiteUrl";
import { getCurrentLocation } from "../../utils/services/locations/CurrentLocation";
import { getStoreOpenTime, isStoreClosed } from "../../utils/services/DateTimeUtils";
import { getImagePath, isChemistStoreLoaded } from "../../utils/services/CommonUtils";
import { getSelectedLocationTitle } from "../../utils/services/locations/UserLocationUtils";
import { MoengageEvents, trackMoengageEvents } from "../../utils/services/webapp-services/MoengageUtils";
import { ScreenPushBackData, selectedLocationForDashboard } from "../../utils/services/subject-behaviour/CommonRxjsService";
import { computeDistance, getChemistStorePicUrl, getSelectedChemistStoreId, roundOffRating } from "../../utils/services/chemist/ChemistStoreUtils";

import { BulletedDotView } from "../../utils/widgets/Common-Widget";
import { GooglePlayBadge } from "../../utils/widgets/CommonAayuLogo";
import { PharmacyListingShimmer } from "../shimmer-component/ScreenShimmer";
import { getCartTotalItemCount } from "../../utils/services/oms/UpsertCartData";
import { CommonLocationHeader } from "../../utils/widgets/CommonWidget/CommonHeader";
import { HomeDelivery, InStorePickUp, PharmacyDiscount } from "../../utils/widgets/chemist/StoreSettingsChips";

import { UserDummyId } from "../../utils/constants/AppConstants";
import { ScreenPushBackCode } from "../../utils/constants/SubjectBehaviousConstant";
import { NavigateFrom, ScreenRoute } from "../../utils/constants/ScreenRouteConstant";

import AppTheme from "../../AppTheme";
import OmsStyles from "../../OmsStyle";
import AppStyles from "../../AppStyles";
import TextStyle from "../../TextStyle";
import Colors from "../../utils/constants/AppColors";

import CommonBottomSheet from "../../utils/modals/CommonBottomSheet";
import LocationSelectionBottomSheet from "../../utils/modals/LocationBottomSheet";

import ModalContent from "../../utils/constants/ModalContentConstant";

import * as OMSAPI from '../../utils/services/api/OMSAPI'
import * as Redux from "../../utils/services/redux/commonRedux";


const PharmacyList = (props) => {

    const reduxState = store.getState()
    const isUserLoggedIn = reduxState.isUserLogin ? true : false

    const [selectedLocation, updateSelectedLocation] = useState(props.route.params?.selectedLocation)

    const [pharmacyList, updatePharmacyList] = useState([]);
    const [loadingPharmacies, setLoadingPharmacies] = useState(true)

    const [bagItemCount, updateBagItemCount] = useState(getCartTotalItemCount())

    const [showLocationBottomSheet, setLocationModal] = useState(false)
    const [blockedLocationModal, setBlockedLocationModal] = useState(false)

    global.allowScrollPharmacyListpage = false,
        global.windowScrollListPageYOffset = 0

    const initPharmacyListData = (response) => {
        if (response == null || response.status == 401) {
            setLoadingPharmacies(false);
        } else {
            updatePharmacyList(response.ssList);
            if (response.ssList.length == 0) {
                trackMoengageEvents(MoengageEvents.oms_no_pharmacy_found)
            } else if (isChemistStoreLoaded()) {
                props.navigation.popToTop()
                props.navigation.replace(ScreenRoute.tab_controller_screen)
            }
            setLoadingPharmacies(false);
        }
    }

    const searchPharmacyList = async (selectedLocation) => {
        var params = {
            'pwa': true,
            'withChemistSite': true,
            'retainFavoritePharmacies': true
        }

        if (isChemistStoreLoaded()) {
            const reduxState: any = store.getState();
            params['selectedPharmacyId'] = getSelectedChemistStoreId(reduxState)
        }

        if (selectedLocation) {
            if (selectedLocation['coordinates'])
                params['curLocation'] = selectedLocation['coordinates']['latitude'] + ',' + selectedLocation['coordinates']['longitude']
            if (selectedLocation['pid'])
                params['placeId'] = selectedLocation['pid']
        }
        if (reduxState.isUserLogin) {
            params['userId'] = reduxState.userDetails['id']
            await OMSAPI.doPost('agent/list_nearby_agents', params).then(
                (response: any) => { initPharmacyListData(response) },
                (err: any) => { console.log("API is failed with error " + err) }
            )
        } else {
            params['userId'] = UserDummyId
            await OMSAPI.doPostGuest('list_nearby_agents', params).then(
                (response: any) => { initPharmacyListData(response) })

        }
    }

    const searchPharmacyListCallback = useCallback(
        debounce(() => searchPharmacyList(selectedLocation)), [])

    function openSelectLocationBottomSheet() {
        setLocationBottomSheet()
    }

    function onLocationSelection(updatedLocation) {
        let eventParams = { pid: location['pid'] }
        trackMoengageEvents(MoengageEvents.delivery_location_selected, eventParams)
        if (location['coordinates']) {
            eventParams['latLng'] = location['coordinates']
        } else if (location['location']) {
            let coordinates = location['location'].split(',')
            location['coordinates'] = { latitude: coordinates[0], longitude: coordinates[1] }
            eventParams['latLng'] = { latitude: coordinates[0], longitude: coordinates[1] }
        }
        trackMoengageEvents(MoengageEvents.oms_delivery_address_select, eventParams)
        if (updatedLocation['pid'] != selectedLocation['pid'] ||
            updatedLocation['aid'] != selectedLocation['aid']) {
            updateSelectedLocation(updatedLocation)
            Redux.updateUserSelectedLocationToRedux(updatedLocation)
            selectedLocationForDashboard.setSelectedLocation(updatedLocation)
            setTimeout(() => {
                setLoadingPharmacies(true)
                searchPharmacyList(updatedLocation)
            }, 200)
        }
    }

    function getUserCurrentLocation() {
        getCurrentLocation(isUserLoggedIn, showBlockedLocationModal).
            then((currentLocation: any) => {
                if (currentLocation) onLocationSelection(currentLocation)
            })
    }

    const searchLocation = () => {
        global.navigateFrom = NavigateFrom.pharmacy_list_for_search_location
        props.navigation.navigate(ScreenRoute.search_locality)
    }

    const addNewAddress = () => {
        props.navigation.navigate(ScreenRoute.upsert_user_address)
    }

    const closeLocationModal = () => {
        setLocationModal(false)
    }

    const setLocationBottomSheet = () => {
        setLocationModal(true)
    }

    const showBlockedLocationModal = () => {
        setBlockedLocationModal(true)
    }

    const closeBlockedLocationModal = () => {
        setBlockedLocationModal(false)
    }

    const pushBackDataSubscriber = () => {
        ScreenPushBackData.getPushBackData().subscribe((data) => {
            if (data['pushBackCode'] ==
                ScreenPushBackCode[NavigateFrom.pharmacy_list_for_search_location]) {
                let fetchLocationData = data['pushBackData']
                onLocationSelection(fetchLocationData)
                ScreenPushBackData.clearPushBackData()
            }
        })
    }

    useEffect(() => {
        if (loadingPharmacies)
            searchPharmacyListCallback()
        pharmacyPageScrollOnFocus()
        pushBackDataSubscriber()
    }, [])

    const pharmacyPageScrollOnFocus = () => {
        const { navigation }: any = props;
        navigation.addListener("focus", () => {
            updateBagItemCount(getCartTotalItemCount())
            if (global.allowScrollPharmacyListpage) {
                window.scrollTo({
                    top: global.windowScrollListPageYOffset,
                    left: 0,
                    behavior: 'auto'
                })
            } else {
                global.allowScrollPharmacyListpage = false;
            }
        });

        navigation.addListener("blur", () => {
            if (!global.allowScrollPharmacyListpage) {
                global.allowScrollPharmacyListpage = true;
            }
        });
    }

    const onPharmacySelect = (pharmacy) => {
        getChemistSiteUrl(pharmacy)
        // let clearCart = false
        // let cartItems = getCartItemFroRedux()
        // if (cartItems.length) {
        //     const cartData = cartItems[0]
        //     if (cartData['pid'] != pharmacy['id']) clearCart = true
        // } else clearCart = true

        // clearRepeatOrderData()
        // if (clearCart) clearCartData()
        // refreshChemistData({ storeId: pharmacy['id'] })

        // Redux.updateChemistData(pharmacy);
        global.windowScrollListPageYOffset = scrollY;
        // props.navigation.navigate(ScreenRoute.selected_pharmacy,
        //     { selectedLocation: selectedLocation })
    }

    return <View>

        <CommonLocationHeader navigation={props.navigation}
            onBackPressRoute={ScreenRoute.oms_detect_user_location}
            onClickBottomChevron={openSelectLocationBottomSheet}
            cartProductsCount={bagItemCount}
            title={getSelectedLocationTitle(selectedLocation)}
            hideCart={true} />

        <ScrollView showsVerticalScrollIndicator={false}>
            {loadingPharmacies ? <View style={[AppStyles.screenViewWithHeader, AppStyles.py12]}>
                <PharmacyListingShimmer /></View> :
                pharmacyList.length > 0 ? <View style={[AppStyles.screenViewWithHeader, AppStyles.py12]}>
                    {pharmacyList.map((pharmacy: any, index) =>
                        <AnimatableView animation="fadeIn" duration={AppTheme.transitionDuration}
                            delay={index ? (index * AppTheme.transitionDuration) / 20 : 0}
                            useNativeDriver key={pharmacy['id']}>

                            <Pressable onPress={() => { onPharmacySelect(pharmacy) }}
                                style={styles.storeCard} onLongPress={() => { console.log('### long press') }}>
                                <View style={{ position: 'relative' }}>
                                    <Image style={{ width: AppTheme.appWidth - 32, height: 124, borderTopRightRadius: 12, borderTopLeftRadius: 12 }}
                                        source={{ uri: getChemistStorePicUrl(pharmacy) }} />
                                    {/* <View style={{ backgroundColor: AppTheme.color.blue.blurColor, opacity: 0.7 }}>
                                        {isStoreClosed(pharmacy) != null && isStoreClosed(pharmacy) ?
                                            <View style={[AppStyles.flexRow, styles.closedView]}>
                                                <Image style={{ paddingRight: 4 }}
                                                    source={{ uri: getImagePath('/images/icons/timer.svg'), height: 12, width: 12 }}></Image>
                                                <Text style={[TextStyle.text12, AppStyles.pl8, { color: AppTheme.color.white }]}>
                                                    Store is currently closed, will open at {getStoreOpenTime(pharmacy)}</Text>
                                            </View> : null
                                        }
                                    </View> */}
                                </View>
                                <View style={{ paddingHorizontal: 16, marginTop: 12 }}>

                                    <Text style={[OmsStyles.text16b]}>{pharmacy.pharmacyName}</Text>
                                    <View style={[AppStyles.flexRow, { alignItems: "center", paddingTop: 8 }]}>
                                        <Image source={{ uri: getImagePath('/images/icons/rating_black.svg'), width: 12, height: 12 }} />
                                        <Text style={OmsStyles.text}> {roundOffRating(pharmacy['actualRating']) ? roundOffRating(pharmacy['actualRating']) : '--'}</Text>
                                        <BulletedDotView marginHorizontal={8} />
                                        <Text style={OmsStyles.text14}>{computeDistance(pharmacy['distance'])}</Text>
                                    </View>
                                    <View style={[AppStyles.flexRow, { paddingTop: 10, flexWrap: 'wrap', justifyContent: "flex-start" }]}>

                                        {pharmacy.discount && pharmacy.discount != '0%' && PharmacyDiscount(pharmacy.discount)}
                                        {pharmacy?.storeSettings?.isProvidingHomeDelivery === true ? HomeDelivery() : InStorePickUp()}

                                    </View>

                                </View>
                            </Pressable></AnimatableView>
                    )}</View> : <View style={[AppStyles.screenViewWithHeader,
                    AppStyles.alignCenter, { backgroundColor: Colors.background }]}>
                    <Image style={{ width: 220, height: 191 }}
                        source={{ uri: getImagePath('/images/icons/download_aayu.svg') }} />
                    <Text style={[TextStyle.text18xb, { marginTop: 32 }]}>
                        Download Aayu App</Text>
                    <Text style={[TextStyle.text16, AppStyles.mx24,
                    { marginTop: 8, color: Colors.grey.text, textAlign: "center" }]}>
                        To experience best healthcare services, download Aayu app and get extra discounts on the medicines orders.</Text>
                    <GooglePlayBadge viewStyle={{ marginTop: 32 }} />
                </View>

            }
        </ScrollView>

        {showLocationBottomSheet && <LocationSelectionBottomSheet
            fromReviewOrder={false}
            isUserLoggedIn={isUserLoggedIn}
            selectedLocation={selectedLocation}
            showLocationModal={showLocationBottomSheet}
            addAddress={addNewAddress}
            closeModal={closeLocationModal}
            searchLocation={searchLocation}
            onSelectSavedLocation={onLocationSelection}
            getUserCurrentLocation={getUserCurrentLocation} />
        }

        <CommonBottomSheet key={'blocked location'}
            showModal={blockedLocationModal}
            modalData={ModalContent.BlockedLocation}
            closeModal={closeBlockedLocationModal}
            primaryAction={searchLocation} />

    </View>
}

export default PharmacyList;

const styles = StyleSheet.create({
    closedView: {
        position: 'absolute', paddingHorizontal: 16, paddingVertical: 6, bottom: 0,
        width: '100%', backgroundColor: AppTheme.color.blue.blurColor
    },
    storeCard: {
        marginTop: 12, shadowRadius: 4, shadowColor: '#00000029', marginHorizontal: 16, borderRadius: 12,
        paddingBottom: 16,
        backgroundColor: AppTheme.color.white
    },
    discount: {
        color: '#00AAC8', backgroundColor: '#00AAC833',
        borderRadius: 12, paddingHorizontal: 6, paddingVertical: 4,
    },

    storePickUp: {
        paddingHorizontal: 6, paddingVertical: 4, marginLeft: 12,
        color: '#8062B0', backgroundColor: '#8062B033', borderRadius: 12, padding: 4
    },

    homeDelivery: {
        marginLeft: 12,
        color: '#0FAC91', backgroundColor: '#0FAC9133', borderRadius: 12, paddingHorizontal: 6, paddingVertical: 4,

    },
    mainContainer: {
        backgroundColor: '#F7F7F8',
        width: AppTheme.appWidth,
        height: '100vh'
    },
    view: {
        justifyContent: 'flex-end',
        margin: 'auto',
        width: AppTheme.appWidth,
        // background: AppTheme.color.white
    },

})
